export const Faq = (() => {
	'use strict';

	let faqBlocks;

	function init() {
		
		faqBlocks = document.querySelectorAll('.pxblock--faq');

		if(faqBlocks.length > 0) {
			initFaq();
		}
	}

	function initFaq() {

		faqBlocks.forEach((block) => {
			let tabs = block.querySelectorAll('.pxblock--faq [data-tab-index]');
			let panes = block.querySelectorAll('.pxblock--faq [data-pane-index]');
			let toggleItemBtns = block.querySelectorAll('.pxblock--faq [data-toggle-item]');
	
			tabs.forEach((tab) => {
				tab.addEventListener('click', (e) => {
					e.preventDefault();
					console.log('click', tab.dataset.tabIndex);
					
					tabs.forEach((tab) => {
						tab.classList.remove('active');
					});

					tab.classList.add('active');
					
					panes.forEach((pane) => {
						console.log(pane.dataset.paneIndex);
						if(tab.dataset.tabIndex === pane.dataset.paneIndex){
							pane.classList.add('active');
						} else {
							pane.classList.remove('active');
						}					
					});
				});
			});
	
			toggleItemBtns.forEach((btn) => {
				btn.addEventListener('click', (e) => {
					e.preventDefault();
					let li = btn.closest('li');
	
					if(li.classList.contains('active')) {
						li.classList.remove('active');
						// btn.innerHTML = '+';
					} else {
						li.classList.add('active');
						// btn.innerHTML = '&mdash;';
					}
				});
			});		
		});
	}

	return {
		init: init,
	};
})();
